import React, { useEffect, useState, useRef, createElement } from 'react';
import { MessageSquare, ThumbsUp, Eye, Plus, Search, X, CheckCircle, Book, MessageCircle, Image as ImageIcon, Send, HelpCircle, Info, Upload, Trash2, CheckCheck, ArrowDownAZ, MessageSquareText, Heart, Filter, ChevronDown, Star, User, MessageSquareDashed, ListFilter, Bookmark, ArrowLeft, Reply, Flag, Users, Building, PenLine, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
// ... existing code ...
interface ForumTopicType {
  id: number;
  title: string;
  author: string;
  authorType: 'student' | 'teacher' | 'manager';
  category: string;
  topic?: string;
  replies: number;
  views: number;
  likes: number;
  time: string;
  content?: string;
  visibility: 'public' | 'private' | 'institution';
  selectedUsers?: string[];
  type: 'question' | 'other';
  bestAnswerId?: number;
  teacherApprovedId?: number;
  solved?: boolean;
  image?: string;
  likedBy?: string[];
  mostLikedAnswerId?: number;
  repliedBy?: string[];
  archived?: boolean;
}
interface ArchivedForumQuestion {
  id: number;
  title: string;
  content?: string;
  subject: string;
  topic: string;
  image?: string;
  forumDate: string;
  archivedDate: string;
  notes: string;
  noteImages: string[];
  bestAnswer?: string | null;
  teacherApproved?: string | null;
  mostLiked?: string | null;
}
const lgsSubjects = [{
  id: 'turkce',
  title: 'Türkçe',
  topics: ['Sözcükte Anlam', 'Deyimler ve Atasözleri', 'Cümlede Anlam', 'Sözel Mantık / Görsel Okuma', 'Parçada Anlam', 'Söz Sanatları', 'Metin Türleri', 'Noktalama İşaretleri', 'Yazım Kuralları', 'Fiilimsiler', 'Cümlenin Öğeleri', 'Cümle Türleri', 'Anlatım Bozukluğu']
}, {
  id: 'matematik',
  title: 'Matematik',
  topics: ['Çarpanlar ve Katlar', 'Üslü Sayılar', 'Köklü Sayılar', 'Veri Analizi', 'Olasılık', 'Cebirsel İfadeler', 'Doğrusal Denklemler ve Eğim', 'Eşitsizlikler', 'Üçgenler', 'Eşlik ve Benzerlik', 'Dönüşüm Geometrisi', 'Geometrik Cisimler']
}, {
  id: 'fen',
  title: 'Fen Bilimleri',
  topics: ['Mevsimler ve İklim', 'DNA ve Genetik Kod', 'Basınç', 'Madde ve Endüstri', 'Basit Makineler', 'Enerji Dönüşümleri', 'Elektrik Yükleri']
}, {
  id: 'inkilap',
  title: 'T.C. İnkılap Tarihi',
  topics: ['Bir Kahraman Doğuyor', 'Milli Uyanış', 'Milli Bir Destan', 'Atatürkçülük', 'Demokratikleşme Çabaları', 'Atatürk Dönemi Dış Politika']
}, {
  id: 'ingilizce',
  title: 'İngilizce',
  topics: ['Friendship', 'Teen Life', 'In The Kitchen', 'On The Phone', 'The Internet', 'Adventures', 'Tourism', 'Chores', 'Science', 'Natural Forces']
}, {
  id: 'din',
  title: 'Din Kültürü',
  topics: ['Kader İnancı', 'Hz. Musa', 'Zekat ve Sadaka', 'Din ve Hayat', 'Hz. Muhammed', "Kur'an-ı Kerim", 'Paylaşma ve Yardımlaşma']
}];
interface IconFilterProps {
  icon: React.ReactNode;
  iconColor: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}
function IconFilter({
  icon,
  iconColor,
  label,
  isActive,
  onClick
}: IconFilterProps) {
  return <button onClick={onClick} className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors ${isActive ? 'bg-purple-500/20 border border-purple-500/50' : 'bg-white/5 hover:bg-white/10 border border-white/10'}`} data-id="element-505">
      <span className={`text-${iconColor} ${isActive ? 'opacity-100' : 'opacity-70'}`} data-id="element-506">
        {icon}
      </span>
      <span className={`text-sm ${isActive ? 'text-white' : 'text-gray-400'}`} data-id="element-507">
        {label}
      </span>
    </button>;
}
interface ForumTopicProps {
  topic: ForumTopicType;
  onClose: () => void;
  onAddReply: (topicId: number, replyContent: string, replyToId?: number) => void;
  onUpdateBestAnswer?: (topicId: number, answerId: number) => void;
  onUpdateTeacherApproved?: (topicId: number, answerId: number) => void;
  onUpdateMostLiked?: (topicId: number, answerId: number) => void;
  onArchive?: (topicId: number) => void;
}
function ForumTopicDetail({
  topic,
  onClose,
  onAddReply,
  onUpdateBestAnswer,
  onUpdateTeacherApproved,
  onUpdateMostLiked,
  onArchive
}: ForumTopicProps) {
  const [replyContent, setReplyContent] = useState('');
  const [replyToId, setReplyToId] = useState<number | undefined>(undefined);
  const [replyToAuthor, setReplyToAuthor] = useState<string | undefined>(undefined);
  const [isLiked, setIsLiked] = useState(topic.likedBy?.includes('currentUser') || false);
  const [isArchived, setIsArchived] = useState(topic.archived || false);
  const [replies, setReplies] = useState<any[]>([{
    id: 1,
    author: 'Zeynep Öğretmen',
    authorType: 'teacher',
    content: 'Bu soruyu çözerken, üslü sayıların özelliklerini doğru kullanmanız önemli. Negatif kuvvetlerin işlem sırasını ve paydaya geçiş kurallarını hatırlayın.',
    time: '2 saat önce',
    likes: 15,
    likedBy: [],
    isTeacherApproved: topic.teacherApprovedId === 1,
    isBestAnswer: topic.bestAnswerId === 1
  }, {
    id: 2,
    author: 'Mehmet K.',
    authorType: 'student',
    content: 'Ben de benzer bir soruyla karşılaşmıştım. Şu şekilde çözdüm: Öncelikle tüm üsleri pozitif yaparak başladım. Sonra ortak paydada topladım.',
    time: '1 saat önce',
    likes: 8,
    likedBy: ['currentUser'],
    isTeacherApproved: topic.teacherApprovedId === 2,
    isBestAnswer: topic.bestAnswerId === 2
  }, {
    id: 3,
    author: 'Ali Öğretmen',
    authorType: 'teacher',
    content: 'Üslü sayılarda negatif kuvvet kuralını unutmayın: a^(-n) = 1/(a^n). Bu tür sorularda önce bütün üsleri pozitif hale getirip, sonra işlemleri yapmak işinizi kolaylaştıracaktır.',
    time: '45 dakika önce',
    likes: 12,
    likedBy: [],
    isTeacherApproved: topic.teacherApprovedId === 3,
    isBestAnswer: topic.bestAnswerId === 3
  }]);
  const replyInputRef = useRef<HTMLTextAreaElement>(null);
  const handleLike = () => {
    setIsLiked(!isLiked);
  };
  const handleArchive = () => {
    setIsArchived(!isArchived);
    if (onArchive) {
      onArchive(topic.id);
    }
  };
  const handleReplyTo = (id: number, author: string) => {
    setReplyToId(id);
    setReplyToAuthor(author);
    if (replyInputRef.current) {
      replyInputRef.current.focus();
    }
  };
  const handleCancelReplyTo = () => {
    setReplyToId(undefined);
    setReplyToAuthor(undefined);
  };
  const handleAddReply = () => {
    if (replyContent.trim()) {
      onAddReply(topic.id, replyContent, replyToId);
      const newReply = {
        id: replies.length + 4,
        author: 'Yönetici',
        authorType: 'manager',
        content: replyContent,
        time: 'Az önce',
        likes: 0,
        likedBy: [],
        isTeacherApproved: false,
        isBestAnswer: false,
        replyToId,
        replyToAuthor
      };
      setReplies([...replies, newReply]);
      setReplyContent('');
      setReplyToId(undefined);
      setReplyToAuthor(undefined);
    }
  };
  const handleReplyLike = (replyId: number) => {
    setReplies(replies.map(reply => {
      if (reply.id === replyId) {
        const isAlreadyLiked = reply.likedBy.includes('currentUser');
        return {
          ...reply,
          likes: isAlreadyLiked ? reply.likes - 1 : reply.likes + 1,
          likedBy: isAlreadyLiked ? reply.likedBy.filter((id: string) => id !== 'currentUser') : [...reply.likedBy, 'currentUser']
        };
      }
      return reply;
    }));
    const sortedReplies = [...replies].sort((a, b) => b.likes - a.likes);
    const mostLikedReply = sortedReplies[0];
    if (mostLikedReply && mostLikedReply.likes > 0 && onUpdateMostLiked && topic.mostLikedAnswerId !== mostLikedReply.id) {
      onUpdateMostLiked(topic.id, mostLikedReply.id);
    }
  };
  const handleSetBestAnswer = (replyId: number) => {
    if (onUpdateBestAnswer) {
      onUpdateBestAnswer(topic.id, replyId);
    }
    setReplies(replies.map(reply => ({
      ...reply,
      isBestAnswer: reply.id === replyId
    })));
  };
  const handleSetTeacherApproved = (replyId: number) => {
    if (onUpdateTeacherApproved) {
      onUpdateTeacherApproved(topic.id, replyId);
    }
    setReplies(replies.map(reply => ({
      ...reply,
      isTeacherApproved: reply.id === replyId
    })));
  };
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Matematik':
        return 'bg-blue-400/10 text-blue-400';
      case 'Türkçe':
        return 'bg-red-400/10 text-red-400';
      case 'Fen Bilimleri':
        return 'bg-green-400/10 text-green-400';
      case 'T.C. İnkılap Tarihi':
        return 'bg-amber-400/10 text-amber-400';
      case 'İngilizce':
        return 'bg-indigo-400/10 text-indigo-400';
      case 'Din Kültürü':
        return 'bg-teal-400/10 text-teal-400';
      default:
        return 'bg-purple-400/10 text-purple-400';
    }
  };
  return <div className="space-y-6" data-id="element-508">
      <div className="flex items-center gap-4" data-id="element-509">
        <button onClick={onClose} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-white text-white hover:bg-white/10 transition-all" data-id="element-510">
          <ArrowLeft className="w-5 h-5" data-id="element-511" />
          Geri
        </button>
        <h1 className="text-2xl font-bold" data-id="element-512">{topic.title}</h1>
      </div>
      <AuroraFloatingCard data-id="element-513">
        <div className="flex justify-between items-start mb-4" data-id="element-514">
          <div data-id="element-515">
            <div className="flex items-center gap-2 mb-1" data-id="element-516">
              <span className="font-medium" data-id="element-517">{topic.author}</span>
              {topic.authorType === 'teacher' && <span className="px-2 py-0.5 text-xs rounded-full bg-blue-500/20 text-blue-400" data-id="element-518">
                  Öğretmen
                </span>}
              {topic.authorType === 'manager' && <span className="px-2 py-0.5 text-xs rounded-full bg-purple-500/20 text-purple-400" data-id="element-519">
                  Yönetici
                </span>}
              <span className="text-sm text-gray-400" data-id="element-520">{topic.time}</span>
            </div>
            <div className="flex flex-wrap gap-2 mt-2" data-id="element-521">
              {topic.category && <span className={`px-2 py-1 rounded-full text-xs ${getCategoryColor(topic.category)}`} data-id="element-522">
                  {topic.category}
                </span>}
              {topic.topic && <span className="px-2 py-1 rounded-full text-xs bg-purple-400/10 text-purple-400" data-id="element-523">
                  {topic.topic}
                </span>}
              {topic.visibility === 'private' && <span className="px-2 py-1 rounded-full text-xs bg-indigo-400/10 text-indigo-400" data-id="element-524">
                  Özel
                </span>}
              {topic.visibility === 'institution' && <span className="px-2 py-1 rounded-full text-xs bg-amber-400/10 text-amber-400" data-id="element-525">
                  Kuruma Özel
                </span>}
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-526">
            <button onClick={handleArchive} className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${isArchived ? 'bg-purple-500/20 text-purple-400' : 'bg-white/5 text-gray-400 hover:bg-white/10'}`} data-id="element-527">
              <Bookmark className="w-4 h-4" fill={isArchived ? 'currentColor' : 'none'} data-id="element-528" />
              <span data-id="element-529">{isArchived ? 'Arşivlendi' : 'Arşive Ekle'}</span>
            </button>
            <button onClick={handleLike} className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${isLiked ? 'bg-purple-500/20 text-purple-400' : 'bg-white/5 text-gray-400 hover:bg-white/10'}`} data-id="element-530">
              <ThumbsUp className="w-4 h-4" fill={isLiked ? 'currentColor' : 'none'} data-id="element-531" />
              <span data-id="element-532">
                {topic.likes + (isLiked ? topic.likedBy?.includes('currentUser') ? 0 : 1 : topic.likedBy?.includes('currentUser') ? -1 : 0)}
              </span>
            </button>
          </div>
        </div>
        <div className="prose prose-invert max-w-none" data-id="element-533">
          <p data-id="element-534">{topic.content}</p>
        </div>
        {topic.image && <div className="mt-4" data-id="element-535">
            <img src={topic.image} alt="Soru görseli" className="rounded-lg max-w-full" data-id="element-536" />
          </div>}
        <div className="flex items-center gap-4 mt-6 text-sm text-gray-400" data-id="element-537">
          <div className="flex items-center gap-1" data-id="element-538">
            <MessageSquare className="w-4 h-4" data-id="element-539" />
            <span data-id="element-540">{topic.replies} yanıt</span>
          </div>
          <div className="flex items-center gap-1" data-id="element-541">
            <Eye className="w-4 h-4" data-id="element-542" />
            <span data-id="element-543">{topic.views} görüntülenme</span>
          </div>
        </div>
      </AuroraFloatingCard>
      <div className="space-y-4" data-id="element-544">
        <h2 className="text-xl font-bold" data-id="element-545">Yanıtlar</h2>
        {replies.map(reply => <AuroraFloatingCard key={reply.id} className={reply.isTeacherApproved ? 'border-2 border-green-500/50' : reply.isBestAnswer ? 'border-2 border-blue-500/50' : reply.author === 'Yönetici' ? 'border-2 border-purple-500/50' : ''} data-id="element-546">
            {reply.replyToId && <div className="mb-2 text-sm text-gray-400 flex items-center" data-id="element-547">
                <span className="mr-1" data-id="element-548">Yanıt:</span>
                <span className="font-medium text-purple-400" data-id="element-549">
                  {reply.replyToAuthor}
                </span>
              </div>}
            <div className="flex justify-between items-start mb-3" data-id="element-550">
              <div className="flex items-center gap-2" data-id="element-551">
                <span className="font-medium" data-id="element-552">{reply.author}</span>
                {reply.authorType === 'teacher' && <span className="px-2 py-0.5 text-xs rounded-full bg-blue-500/20 text-blue-400" data-id="element-553">
                    Öğretmen
                  </span>}
                {reply.authorType === 'manager' && <span className="px-2 py-0.5 text-xs rounded-full bg-purple-500/20 text-purple-400" data-id="element-554">
                    Yönetici
                  </span>}
                <span className="text-sm text-gray-400" data-id="element-555">{reply.time}</span>
                {reply.isTeacherApproved && <span className="px-2 py-0.5 text-xs rounded-full bg-green-500/20 text-green-400 flex items-center gap-1" data-id="element-556">
                    <CheckCheck className="w-3 h-3" data-id="element-557" /> Öğretmen Onaylı
                  </span>}
                {reply.isBestAnswer && <span className="px-2 py-0.5 text-xs rounded-full bg-blue-500/20 text-blue-400 flex items-center gap-1" data-id="element-558">
                    <Star className="w-3 h-3" data-id="element-559" /> En İyi Cevap
                  </span>}
              </div>
              <div className="flex items-center gap-2" data-id="element-560">
                <button onClick={() => handleReplyTo(reply.id, reply.author)} className="p-1.5 rounded-lg bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white transition-colors" title="Yanıtla" data-id="element-561">
                  <MessageSquare className="w-4 h-4" data-id="element-562" />
                </button>
                <button onClick={() => handleReplyLike(reply.id)} className={`flex items-center gap-1 p-1.5 rounded-lg transition-colors ${reply.likedBy.includes('currentUser') ? 'bg-purple-500/20 text-purple-400' : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white'}`} title="Beğen" data-id="element-563">
                  <Heart className="w-4 h-4" fill={reply.likedBy.includes('currentUser') ? 'currentColor' : 'none'} data-id="element-564" />
                  <span data-id="element-565">{reply.likes}</span>
                </button>
              </div>
            </div>
            <div className="prose prose-invert max-w-none" data-id="element-566">
              <p data-id="element-567">{reply.content}</p>
            </div>
          </AuroraFloatingCard>)}
        <AuroraFloatingCard data-id="element-568">
          {replyToId && <div className="mb-3 flex items-center justify-between bg-purple-500/10 text-purple-400 px-3 py-2 rounded-lg" data-id="element-569">
              <div className="flex items-center gap-2" data-id="element-570">
                <MessageSquare className="w-4 h-4" data-id="element-571" />
                <span data-id="element-572">
                  <span className="text-gray-400" data-id="element-573">Yanıtlıyorsun:</span>{' '}
                  {replyToAuthor}
                </span>
              </div>
              <button onClick={handleCancelReplyTo} className="text-gray-400 hover:text-white" data-id="element-574">
                <Trash2 className="w-4 h-4" data-id="element-575" />
              </button>
            </div>}
          <textarea ref={replyInputRef} value={replyContent} onChange={e => setReplyContent(e.target.value)} placeholder="Yanıtınızı buraya yazın..." className="w-full bg-white/5 text-white rounded-lg px-4 py-3 min-h-[120px] focus:ring-2 ring-purple-500/20 mb-3" data-id="element-576" />
          <div className="flex items-center justify-between" data-id="element-577">
            <div className="flex gap-2" data-id="element-578">
              <button className="p-2 rounded-lg bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white transition-colors" data-id="element-579">
                <ImageIcon className="w-5 h-5" data-id="element-580" />
              </button>
            </div>
            <button onClick={handleAddReply} disabled={!replyContent.trim()} className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${replyContent.trim() ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white' : 'bg-gray-800 text-gray-500 cursor-not-allowed'}`} data-id="element-581">
              <Send className="w-4 h-4" data-id="element-582" />
              Yanıtla
            </button>
          </div>
        </AuroraFloatingCard>
      </div>
    </div>;
}
interface NewForumTopicProps {
  onClose: () => void;
  onSubmit: (topic: {
    title: string;
    category: string;
    topic: string;
    content: string;
    image: File | null;
    visibility: 'public' | 'institution' | 'private';
    selectedUsers: string[];
  }) => void;
}
function NewForumTopic({
  onClose,
  onSubmit
}: NewForumTopicProps) {
  const [form, setForm] = useState({
    title: '',
    category: '',
    topic: '',
    content: '',
    image: null as File | null,
    visibility: 'public' as 'public' | 'institution' | 'private'
  });
  const [availableTopics, setAvailableTopics] = useState<string[]>([]);
  const [activeTab, setActiveTab] = useState<'question' | 'other'>('question');
  const [selectedTeachers, setSelectedTeachers] = useState<string[]>([]);
  const [searchTeacher, setSearchTeacher] = useState('');
  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const searchRef = useRef<HTMLDivElement>(null);
  const availableTeachers = [{
    id: '1',
    name: 'Ahmet Yılmaz',
    subject: 'Matematik'
  }, {
    id: '2',
    name: 'Zeynep Kaya',
    subject: 'Türkçe'
  }, {
    id: '3',
    name: 'Mehmet Demir',
    subject: 'Fen Bilimleri'
  }, {
    id: '4',
    name: 'Ayşe Şahin',
    subject: 'İngilizce'
  }, {
    id: '5',
    name: 'Ali Öztürk',
    subject: 'Tarih'
  }];
  useEffect(() => {
    if (form.category) {
      const selectedSubject = lgsSubjects.find(subject => subject.title === form.category);
      if (selectedSubject) {
        setAvailableTopics(selectedSubject.topics);
        setForm(prev => ({
          ...prev,
          topic: ''
        }));
      } else {
        setAvailableTopics([]);
      }
    } else {
      setAvailableTopics([]);
    }
  }, [form.category]);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowTeacherDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const filteredTeachers = availableTeachers.filter(teacher => (teacher.name.toLowerCase().includes(searchTeacher.toLowerCase()) || teacher.subject.toLowerCase().includes(searchTeacher.toLowerCase())) && !selectedTeachers.includes(teacher.id));
  const handleRemoveTeacher = (teacherId: string) => {
    setSelectedTeachers(selectedTeachers.filter(id => id !== teacherId));
  };
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setForm({
        ...form,
        image: file
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageClick = () => {
    fileInputRef.current?.click();
  };
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add('border-purple-500');
  };
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove('border-purple-500');
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove('border-purple-500');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setForm({
        ...form,
        image: file
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleRemoveImage = () => {
    setForm({
      ...form,
      image: null
    });
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const isFormValid = () => {
    if (!form.title || !form.content) {
      return false;
    }
    if (activeTab === 'question') {
      if (!form.category) {
        return false;
      }
      if (form.category !== 'Diğer' && !form.topic) {
        return false;
      }
    }
    if (form.visibility === 'private' && selectedTeachers.length === 0) {
      return false;
    }
    return true;
  };
  const handleSubmit = () => {
    onSubmit({
      ...form,
      selectedUsers: selectedTeachers,
      image: form.image
    });
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50 overflow-y-auto" data-id="element-583">
      <AuroraFloatingCard className="w-full max-w-3xl my-8" data-id="element-584">
        <div className="p-6 border-b border-gray-800" data-id="element-585">
          <div className="flex justify-between items-center" data-id="element-586">
            <h2 className="text-2xl font-bold" data-id="element-587">Yeni Konu</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-588">
              <X className="w-6 h-6" data-id="element-589" />
            </button>
          </div>
        </div>
        <div className="p-6 space-y-6 max-h-[calc(100vh-200px)] overflow-y-auto" data-id="element-590">
          <div className="border-b border-gray-800" data-id="element-591">
            <div className="flex" data-id="element-592">
              <button onClick={() => setActiveTab('question')} className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'question' ? 'text-purple-400' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-593">
                Soru Çözüm
                {activeTab === 'question' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-purple-500" data-id="element-594"></span>}
              </button>
              <button onClick={() => setActiveTab('other')} className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'other' ? 'text-purple-400' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-595">
                Diğer
                {activeTab === 'other' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-purple-500" data-id="element-596"></span>}
              </button>
            </div>
          </div>
          <div className="space-y-2" data-id="element-597">
            <label className="text-sm font-medium text-gray-300" data-id="element-598">Başlık</label>
            <input type="text" value={form.title} onChange={e => setForm({
            ...form,
            title: e.target.value
          })} className="w-full bg-white/5 text-white rounded-lg px-4 py-3 focus:ring-2 ring-purple-500/20 border border-white/10 focus:border-purple-500/50" placeholder="Konu başlığını girin..." data-id="element-599" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-600">
            <div className="space-y-2" data-id="element-601">
              <label className="text-sm font-medium text-gray-300" data-id="element-602">
                Ders Seç
              </label>
              <select value={form.category} onChange={e => setForm({
              ...form,
              category: e.target.value
            })} className="w-full bg-black/50 text-white rounded-lg px-4 py-3 focus:ring-2 ring-purple-500/20 border border-white/10 focus:border-purple-500/50" data-id="element-603">
                <option value="" data-id="element-604">Ders Seçiniz</option>
                {activeTab === 'other' && <option value="Diğer" data-id="element-605">Diğer</option>}
                {lgsSubjects.map(subject => <option key={subject.id} value={subject.title} data-id="element-606">
                    {subject.title}
                  </option>)}
              </select>
            </div>
            <div className="space-y-2" data-id="element-607">
              <label className="text-sm font-medium text-gray-300" data-id="element-608">
                Konu Seç
              </label>
              <select value={form.topic} onChange={e => setForm({
              ...form,
              topic: e.target.value
            })} disabled={!form.category || form.category === 'Diğer'} className={`w-full bg-black/50 text-white rounded-lg px-4 py-3 focus:ring-2 ring-purple-500/20 border border-white/10 ${form.category && form.category !== 'Diğer' ? 'focus:border-purple-500/50' : 'opacity-50 cursor-not-allowed'}`} data-id="element-609">
                <option value="" data-id="element-610">Konu Seçiniz</option>
                {availableTopics.map(topic => <option key={topic} value={topic} data-id="element-611">
                    {topic}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="space-y-2" data-id="element-612">
            <label className="text-sm font-medium text-gray-300" data-id="element-613">İçerik</label>
            <div className="relative" data-id="element-614">
              <textarea value={form.content} onChange={e => setForm({
              ...form,
              content: e.target.value
            })} className="w-full bg-white/5 text-white rounded-lg px-4 py-3 min-h-[150px] focus:ring-2 ring-purple-500/20 border border-white/10 focus:border-purple-500/50 resize-none" placeholder="Konunuzu detaylı bir şekilde açıklayın..." data-id="element-615" />
            </div>
          </div>
          <div className="space-y-2" data-id="element-616">
            <label className="text-sm font-medium text-gray-300" data-id="element-617">
              Görsel Ekle (İsteğe Bağlı)
            </label>
            <input type="file" ref={fileInputRef} onChange={handleImageChange} accept="image/*" className="hidden" data-id="element-618" />
            {!imagePreview ? <div onClick={handleImageClick} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className="border-2 border-dashed border-purple-500/50 rounded-lg p-8 text-center cursor-pointer hover:bg-white/5 transition-colors" data-id="element-619">
                <div className="flex flex-col items-center gap-2" data-id="element-620">
                  <ImageIcon className="w-10 h-10 text-purple-400" data-id="element-621" />
                  <p className="text-purple-400" data-id="element-622">
                    Görseli buraya sürükle veya tıklayarak seç
                  </p>
                  <p className="text-xs text-gray-400 mt-2" data-id="element-623">
                    PNG, JPG veya GIF formatında, max 5MB
                  </p>
                </div>
              </div> : <div className="relative mt-2 rounded-lg overflow-hidden border border-gray-700" data-id="element-624">
                <img src={imagePreview} alt="Preview" className="w-full max-h-60 object-contain bg-black/30" data-id="element-625" />
                <button type="button" onClick={handleRemoveImage} className="absolute top-2 right-2 p-1.5 bg-red-500/80 text-white rounded-full hover:bg-red-600 transition-colors" data-id="element-626">
                  <X className="w-4 h-4" data-id="element-627" />
                </button>
              </div>}
          </div>
          <div className="space-y-3" data-id="element-628">
            <label className="text-sm font-medium text-gray-300" data-id="element-629">
              Görünürlük
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-630">
              <label className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${form.visibility === 'public' ? 'bg-purple-500/20 border border-purple-500/50' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`} data-id="element-631">
                <div className="relative flex items-center justify-center" data-id="element-632">
                  <input type="radio" name="visibility" checked={form.visibility === 'public'} onChange={() => setForm({
                  ...form,
                  visibility: 'public'
                })} className="sr-only" data-id="element-633" />
                  <div className={`w-5 h-5 rounded-full border ${form.visibility === 'public' ? 'border-purple-500' : 'border-gray-400'}`} data-id="element-634"></div>
                  {form.visibility === 'public' && <div className="absolute w-3 h-3 rounded-full bg-purple-500" data-id="element-635"></div>}
                </div>
                <div className="flex items-center gap-2" data-id="element-636">
                  <Users className={`w-5 h-5 ${form.visibility === 'public' ? 'text-purple-400' : 'text-gray-400'}`} data-id="element-637" />
                  <span className={form.visibility === 'public' ? 'text-purple-400' : 'text-gray-300'} data-id="element-638">
                    Herkese Açık
                  </span>
                </div>
              </label>
              <label className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${form.visibility === 'institution' ? 'bg-purple-500/20 border border-purple-500/50' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`} data-id="element-639">
                <div className="relative flex items-center justify-center" data-id="element-640">
                  <input type="radio" name="visibility" checked={form.visibility === 'institution'} onChange={() => setForm({
                  ...form,
                  visibility: 'institution'
                })} className="sr-only" data-id="element-641" />
                  <div className={`w-5 h-5 rounded-full border ${form.visibility === 'institution' ? 'border-purple-500' : 'border-gray-400'}`} data-id="element-642"></div>
                  {form.visibility === 'institution' && <div className="absolute w-3 h-3 rounded-full bg-purple-500" data-id="element-643"></div>}
                </div>
                <div className="flex items-center gap-2" data-id="element-644">
                  <Building className={`w-5 h-5 ${form.visibility === 'institution' ? 'text-purple-400' : 'text-gray-400'}`} data-id="element-645" />
                  <span className={form.visibility === 'institution' ? 'text-purple-400' : 'text-gray-300'} data-id="element-646">
                    Kurumum
                  </span>
                </div>
              </label>
              <label className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${form.visibility === 'private' ? 'bg-purple-500/20 border border-purple-500/50' : 'bg-white/5 border border-white/10 hover:bg-white/10'}`} data-id="element-647">
                <div className="relative flex items-center justify-center" data-id="element-648">
                  <input type="radio" name="visibility" checked={form.visibility === 'private'} onChange={() => setForm({
                  ...form,
                  visibility: 'private'
                })} className="sr-only" data-id="element-649" />
                  <div className={`w-5 h-5 rounded-full border ${form.visibility === 'private' ? 'border-purple-500' : 'border-gray-400'}`} data-id="element-650"></div>
                  {form.visibility === 'private' && <div className="absolute w-3 h-3 rounded-full bg-purple-500" data-id="element-651"></div>}
                </div>
                <div className="flex items-center gap-2" data-id="element-652">
                  <User className={`w-5 h-5 ${form.visibility === 'private' ? 'text-purple-400' : 'text-gray-400'}`} data-id="element-653" />
                  <span className={form.visibility === 'private' ? 'text-purple-400' : 'text-gray-300'} data-id="element-654">
                    Özel
                  </span>
                </div>
              </label>
            </div>
          </div>
          {form.visibility === 'private' && <div className="space-y-2" data-id="element-655">
              <label className="text-sm font-medium text-gray-300" data-id="element-656">
                Öğretmen Seç
              </label>
              <div className="space-y-3" ref={searchRef} data-id="element-657">
                <div className="relative" data-id="element-658">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-659" />
                  <input type="text" value={searchTeacher} onChange={e => {
                setSearchTeacher(e.target.value);
                if (e.target.value) {
                  setShowTeacherDropdown(true);
                }
              }} onFocus={() => {
                if (searchTeacher) {
                  setShowTeacherDropdown(true);
                }
              }} className="w-full bg-white/5 text-white rounded-lg pl-10 pr-4 py-3 focus:ring-2 ring-purple-500/20 border border-white/10 focus:border-purple-500/50" placeholder="Öğretmen adı veya branşı..." data-id="element-660" />
                </div>
                {selectedTeachers.length > 0 && <div className="flex flex-wrap gap-2 mt-2" data-id="element-661">
                    {selectedTeachers.map(teacherId => {
                const teacher = availableTeachers.find(t => t.id === teacherId);
                if (!teacher) return null;
                return <span key={teacherId} className="px-3 py-1.5 rounded-full bg-purple-500/20 text-purple-400 text-sm flex items-center gap-1" data-id="element-662">
                          {teacher.name} ({teacher.subject})
                          <button onClick={() => handleRemoveTeacher(teacherId)} className="ml-1 hover:text-white" data-id="element-663">
                            <X className="w-4 h-4" data-id="element-664" />
                          </button>
                        </span>;
              })}
                  </div>}
                {showTeacherDropdown && searchTeacher && <div className="absolute z-10 mt-1 w-full bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-665">
                    {filteredTeachers.length > 0 ? filteredTeachers.map(teacher => <button key={teacher.id} onClick={() => {
                setSelectedTeachers([...selectedTeachers, teacher.id]);
                setSearchTeacher('');
                setShowTeacherDropdown(false);
              }} className="w-full px-4 py-2 text-left hover:bg-purple-500/20 text-white flex items-center gap-2" data-id="element-666">
                          <User className="w-4 h-4 text-gray-400" data-id="element-667" />
                          <div data-id="element-668">
                            <div className="font-medium" data-id="element-669">{teacher.name}</div>
                            <div className="text-xs text-gray-400" data-id="element-670">
                              {teacher.subject}
                            </div>
                          </div>
                        </button>) : <div className="px-4 py-3 text-gray-400 text-center" data-id="element-671">
                        Sonuç bulunamadı
                      </div>}
                  </div>}
              </div>
            </div>}
        </div>
        <div className="p-6 border-t border-gray-800 flex justify-end gap-3" data-id="element-672">
          <button onClick={onClose} className="px-5 py-2.5 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-673">
            İptal
          </button>
          <button onClick={() => handleSubmit()} disabled={!isFormValid()} className={`px-5 py-2.5 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg transition-colors flex items-center gap-2 ${!isFormValid() ? 'opacity-50 cursor-not-allowed' : 'hover:from-purple-700 hover:to-indigo-700'}`} data-id="element-674">
            <Send className="w-4 h-4" data-id="element-675" />
            Gönder
          </button>
        </div>
      </AuroraFloatingCard>
    </div>;
}
export function Forum() {
  const navigate = useNavigate();
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Matematik':
        return 'bg-blue-400/10 text-blue-400';
      case 'Türkçe':
        return 'bg-red-400/10 text-red-400';
      case 'Fen Bilimleri':
        return 'bg-green-400/10 text-green-400';
      case 'T.C. İnkılap Tarihi':
        return 'bg-amber-400/10 text-amber-400';
      case 'İngilizce':
        return 'bg-indigo-400/10 text-indigo-400';
      case 'Din Kültürü':
        return 'bg-teal-400/10 text-teal-400';
      default:
        return 'bg-purple-400/10 text-purple-400';
    }
  };
  const [topics, setTopics] = useState<ForumTopicType[]>(() => {
    const savedTopics = localStorage.getItem('forumTopics_manager');
    return savedTopics ? JSON.parse(savedTopics) : [{
      id: 1,
      title: 'Öğrencilere nasıl daha etkili motivasyon sağlayabiliriz?',
      author: 'Ahmet Yönetici',
      authorType: 'manager',
      category: 'Matematik',
      topic: 'Üslü Sayılar',
      replies: 5,
      views: 123,
      likes: 8,
      likedBy: [],
      time: '2 saat önce',
      visibility: 'institution',
      type: 'other',
      solved: false,
      repliedBy: [],
      content: 'Kurumumuzdaki öğrencilerin LGS sürecinde motivasyonlarını artırmak için hangi yöntemleri uyguluyorsunuz? Başarı hikayelerinizi paylaşır mısınız?'
    }, {
      id: 2,
      title: 'LGS Fen Bilimleri müfredatı hakkında öğretmen görüşleri',
      author: 'Zeynep K.',
      authorType: 'teacher',
      category: 'Fen Bilimleri',
      topic: 'Genel',
      replies: 12,
      views: 345,
      likes: 24,
      likedBy: [],
      time: '5 saat önce',
      visibility: 'public',
      type: 'other',
      repliedBy: [],
      content: 'Fen Bilimleri müfredatındaki bazı konuların öğrenciler için çok yoğun olduğunu düşünüyorum. Bu konuda sizin görüşleriniz neler?'
    }, {
      id: 3,
      title: 'Öğrenci başarı takibi için hangi sistemleri kullanıyorsunuz?',
      author: 'Mehmet Y.',
      authorType: 'manager',
      category: 'Türkçe',
      topic: 'Genel',
      replies: 8,
      views: 234,
      likes: 15,
      likedBy: [],
      time: '1 gün önce',
      visibility: 'institution',
      type: 'other',
      repliedBy: [],
      content: 'Kurumumda öğrenci başarı takibi için dijital bir sistem kurmak istiyorum. Hangi araçları önerirsiniz?'
    }];
  });
  const [selectedTopic, setSelectedTopic] = useState<ForumTopicType | null>(null);
  const [activeTab, setActiveTab] = useState<'question' | 'other'>('other');
  const [searchTerm, setSearchTerm] = useState('');
  const [showNewTopic, setShowNewTopic] = useState(false);
  const [selectedSubjectFilter, setSelectedSubjectFilter] = useState<string>('');
  const [selectedTopicFilter, setSelectedTopicFilter] = useState<string>('');
  const [availableTopicFilters, setAvailableTopicFilters] = useState<string[]>([]);
  const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
  const [showTopicDropdown, setShowTopicDropdown] = useState(false);
  const [personalFilter, setPersonalFilter] = useState<'all' | 'my-topics' | 'my-replies'>('all');
  const [activeFilters, setActiveFilters] = useState<{
    teacherApproved: boolean;
    studentSelected: boolean;
    mostLiked: boolean;
  }>({
    teacherApproved: false,
    studentSelected: false,
    mostLiked: false
  });
  const [visibilityFilter, setVisibilityFilter] = useState<'all' | 'public' | 'institution'>('all');
  const [showVisibilityDropdown, setShowVisibilityDropdown] = useState(false);
  const [sortOption, setSortOption] = useState<'newest' | 'mostReplies' | 'mostLikes'>('newest');
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  useEffect(() => {
    if (selectedSubjectFilter) {
      const subject = lgsSubjects.find(s => s.title === selectedSubjectFilter);
      if (subject) {
        setAvailableTopicFilters(subject.topics);
      } else {
        setAvailableTopicFilters([]);
      }
      setSelectedTopicFilter('');
    } else {
      setAvailableTopicFilters([]);
      setSelectedTopicFilter('');
    }
  }, [selectedSubjectFilter]);
  useEffect(() => {
    localStorage.setItem('forumTopics_manager', JSON.stringify(topics));
  }, [topics]);
  const sortTopics = (topics: ForumTopicType[]) => {
    switch (sortOption) {
      case 'newest':
        return [...topics].sort((a, b) => {
          if (a.time === 'Şimdi') return -1;
          if (b.time === 'Şimdi') return 1;
          return a.time < b.time ? 1 : -1;
        });
      case 'mostReplies':
        return [...topics].sort((a, b) => b.replies - a.replies);
      case 'mostLikes':
        return [...topics].sort((a, b) => b.likes - a.likes);
      default:
        return topics;
    }
  };
  const filteredTopics = topics.filter(topic => topic.type === activeTab).filter(topic => topic.title.toLowerCase().includes(searchTerm.toLowerCase()) || topic.category.toLowerCase().includes(searchTerm.toLowerCase()) || topic.content && topic.content.toLowerCase().includes(searchTerm.toLowerCase())).filter(topic => selectedSubjectFilter ? topic.category === selectedSubjectFilter : true).filter(topic => selectedTopicFilter ? topic.topic === selectedTopicFilter : true).filter(topic => {
    if (personalFilter === 'my-topics') {
      return topic.author === 'Ahmet Yönetici';
    } else if (personalFilter === 'my-replies') {
      return (topic.repliedBy || []).includes('currentUser');
    }
    return true;
  }).filter(topic => {
    if (visibilityFilter === 'all') {
      return true;
    } else if (visibilityFilter === 'public') {
      return topic.visibility === 'public';
    } else if (visibilityFilter === 'institution') {
      return topic.visibility === 'institution';
    }
    return true;
  }).filter(topic => {
    if (!activeFilters.teacherApproved && !activeFilters.studentSelected && !activeFilters.mostLiked) {
      return true;
    }
    return activeFilters.teacherApproved && topic.teacherApprovedId || activeFilters.studentSelected && topic.bestAnswerId || activeFilters.mostLiked && topic.mostLikedAnswerId && (!topic.teacherApprovedId || topic.mostLikedAnswerId !== topic.teacherApprovedId) && (!topic.bestAnswerId || topic.mostLikedAnswerId !== topic.bestAnswerId);
  });
  const sortedAndFilteredTopics = sortTopics(filteredTopics);
  const handleSubmitNewTopic = (topicData: any) => {
    const newTopic: ForumTopicType = {
      id: Date.now(),
      title: topicData.title,
      author: 'Ahmet Yönetici',
      authorType: 'manager',
      category: topicData.category || '',
      topic: topicData.topic || '',
      replies: 0,
      views: 0,
      likes: 0,
      likedBy: [],
      time: 'Şimdi',
      content: topicData.content,
      visibility: topicData.visibility || 'public',
      selectedUsers: topicData.selectedUsers || [],
      type: activeTab,
      image: topicData.image ? URL.createObjectURL(topicData.image) : undefined,
      repliedBy: []
    };
    const updatedTopics = [newTopic, ...topics];
    setTopics(updatedTopics);
    setShowNewTopic(false);
    setSelectedTopic(newTopic);
  };
  const handleAddReply = (topicId: number, replyContent: string, replyToId?: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        const updatedReplies = topic.replies + 1;
        const updatedRepliedBy = topic.repliedBy || [];
        if (!updatedRepliedBy.includes('currentUser')) {
          updatedRepliedBy.push('currentUser');
        }
        return {
          ...topic,
          replies: updatedReplies,
          repliedBy: updatedRepliedBy
        };
      }
      return topic;
    }));
  };
  const handleLikeTopic = (topicId: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        const isLiked = (topic.likedBy || []).includes('currentUser');
        return {
          ...topic,
          likes: isLiked ? topic.likes - 1 : topic.likes + 1,
          likedBy: isLiked ? (topic.likedBy || []).filter(id => id !== 'currentUser') : [...(topic.likedBy || []), 'currentUser']
        };
      }
      return topic;
    }));
  };
  const handleResetFilters = () => {
    setSelectedSubjectFilter('');
    setSelectedTopicFilter('');
    setAvailableTopicFilters([]);
    setPersonalFilter('all');
  };
  const handleArchiveTopic = (topicId: number) => {
    setTopics(topics.map(topic => {
      if (topic.id === topicId) {
        const isArchived = topic.archived || false;
        return {
          ...topic,
          archived: !isArchived
        };
      }
      return topic;
    }));
  };
  return <div className="space-y-6 p-4" data-id="element-676">
      {!selectedTopic ? <>
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-677">
            <h1 className="text-2xl font-bold" data-id="element-678">Forum</h1>
            <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-679">
              <div className="relative flex-1 sm:w-64" data-id="element-680">
                <div className="relative" data-id="element-681">
                  <div className="relative bg-gray-800/30 border border-purple-500/20 rounded-lg" data-id="element-682">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-400" data-id="element-683" />
                    <input type="text" placeholder="Ara..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full bg-transparent text-white rounded-lg pl-10 pr-4 py-2 focus:outline-none border-none" data-id="element-684" />
                  </div>
                </div>
              </div>
              <button onClick={() => setShowNewTopic(true)} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg text-white hover:from-purple-700 hover:to-indigo-700 transition-colors whitespace-nowrap" data-id="element-685">
                <Plus className="w-4 h-4" data-id="element-686" />
                Yeni Konu
              </button>
            </div>
          </div>
          <div className="flex flex-wrap gap-3 mb-4" data-id="element-687">
            <div className="relative" data-id="element-688">
              <div className="relative bg-gray-800/30 border border-purple-500/20 rounded-lg flex" data-id="element-689">
                <button onClick={() => setPersonalFilter('all')} className={`px-4 py-2 flex items-center gap-2 ${personalFilter === 'all' ? 'text-white bg-purple-600/30' : 'text-gray-300 hover:bg-purple-600/10'} transition-colors`} data-id="element-690">
                  <ListFilter className="w-4 h-4" data-id="element-691" />
                  <span data-id="element-692">Tüm Konular</span>
                </button>
                <button onClick={() => setPersonalFilter('my-topics')} className={`px-4 py-2 flex items-center gap-2 ${personalFilter === 'my-topics' ? 'text-white bg-purple-600/30' : 'text-gray-300 hover:bg-purple-600/10'} transition-colors`} data-id="element-693">
                  <User className="w-4 h-4" data-id="element-694" />
                  <span data-id="element-695">Açtıklarım</span>
                </button>
                <button onClick={() => setPersonalFilter('my-replies')} className={`px-4 py-2 flex items-center gap-2 ${personalFilter === 'my-replies' ? 'text-white bg-purple-600/30' : 'text-gray-300 hover:bg-purple-600/10'} transition-colors`} data-id="element-696">
                  <MessageSquareDashed className="w-4 h-4" data-id="element-697" />
                  <span data-id="element-698">Yanıtladıklarım</span>
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-3 mb-4" data-id="element-699">
            <div className="relative" data-id="element-700">
              <button onClick={() => setShowSubjectDropdown(!showSubjectDropdown)} className="flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 hover:border-purple-500/50 transition-colors" data-id="element-701">
                <Filter className="w-4 h-4" data-id="element-702" />
                <span data-id="element-703">Ders: </span>
                <span className="text-purple-400" data-id="element-704">
                  {selectedSubjectFilter || 'Tümü'}
                </span>
                <ChevronDown className="w-4 h-4 ml-1" data-id="element-705" />
              </button>
              {showSubjectDropdown && <div className="absolute left-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-706">
                  <button onClick={() => {
              setSelectedSubjectFilter('');
              setShowSubjectDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedSubjectFilter === '' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-707">
                    Tümü
                  </button>
                  {lgsSubjects.map(subject => <button key={subject.id} onClick={() => {
              setSelectedSubjectFilter(subject.title);
              setShowSubjectDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedSubjectFilter === subject.title ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-708">
                      {subject.title}
                    </button>)}
                </div>}
            </div>
            <div className="relative" data-id="element-709">
              <button onClick={() => {
            if (selectedSubjectFilter) {
              setShowTopicDropdown(!showTopicDropdown);
            }
          }} disabled={!selectedSubjectFilter} className={`flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 transition-colors ${selectedSubjectFilter ? 'hover:border-purple-500/50' : 'opacity-50 cursor-not-allowed'}`} data-id="element-710">
                <Filter className="w-4 h-4" data-id="element-711" />
                <span data-id="element-712">Konu: </span>
                <span className="text-purple-400" data-id="element-713">
                  {selectedTopicFilter || 'Tümü'}
                </span>
                <ChevronDown className="w-4 h-4 ml-1" data-id="element-714" />
              </button>
              {showTopicDropdown && selectedSubjectFilter && <div className="absolute left-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-715">
                  <button onClick={() => {
              setSelectedTopicFilter('');
              setShowTopicDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedTopicFilter === '' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-716">
                    Tümü
                  </button>
                  {availableTopicFilters.map(topic => <button key={topic} onClick={() => {
              setSelectedTopicFilter(topic);
              setShowTopicDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${selectedTopicFilter === topic ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-717">
                      {topic}
                    </button>)}
                </div>}
            </div>
            <div className="relative" data-id="element-718">
              <button onClick={() => setShowVisibilityDropdown(!showVisibilityDropdown)} className="flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 hover:border-purple-500/50 transition-colors" data-id="element-719">
                <Eye className="w-4 h-4" data-id="element-720" />
                <span data-id="element-721">Görünürlük: </span>
                <span className="text-purple-400" data-id="element-722">
                  {visibilityFilter === 'all' ? 'Tümü' : visibilityFilter === 'public' ? 'Herkese Açık' : 'Kuruma Özel'}
                </span>
                <ChevronDown className="w-4 h-4 ml-1" data-id="element-723" />
              </button>
              {showVisibilityDropdown && <div className="absolute left-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-724">
                  <button onClick={() => {
              setVisibilityFilter('all');
              setShowVisibilityDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${visibilityFilter === 'all' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-725">
                    Tümü
                  </button>
                  <button onClick={() => {
              setVisibilityFilter('public');
              setShowVisibilityDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${visibilityFilter === 'public' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-726">
                    Herkese Açık
                  </button>
                  <button onClick={() => {
              setVisibilityFilter('institution');
              setShowVisibilityDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${visibilityFilter === 'institution' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-727">
                    Sadece Kuruma Özel
                  </button>
                </div>}
            </div>
            {(selectedSubjectFilter || selectedTopicFilter || personalFilter !== 'all' || visibilityFilter !== 'all') && <button onClick={() => {
          handleResetFilters();
          setVisibilityFilter('all');
        }} className="flex items-center gap-2 px-4 py-2 bg-red-500/20 text-red-400 rounded-lg border border-red-500/30 hover:bg-red-500/30 transition-colors" data-id="element-728">
                <X className="w-4 h-4" data-id="element-729" />
                Filtreleri Temizle
              </button>}
          </div>
          <div className="mb-6" data-id="element-730">
            <div className="border-b border-gray-800" data-id="element-731">
              <div className="flex" data-id="element-732">
                <button onClick={() => setActiveTab('question')} className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'question' ? 'text-purple-400' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-733">
                  Soru Çözüm
                  {activeTab === 'question' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-purple-500" data-id="element-734"></span>}
                </button>
                <button onClick={() => setActiveTab('other')} className={`px-6 py-3 font-medium text-sm relative ${activeTab === 'other' ? 'text-purple-400' : 'text-gray-400 hover:text-gray-300'}`} data-id="element-735">
                  Diğer
                  {activeTab === 'other' && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-purple-500" data-id="element-736"></span>}
                </button>
              </div>
            </div>
          </div>
          <div className="flex justify-end mb-4" data-id="element-737">
            <div className="relative" data-id="element-738">
              <button onClick={() => setShowSortDropdown(!showSortDropdown)} className="flex items-center gap-2 px-4 py-2 bg-black/50 text-white rounded-lg border border-white/10 hover:border-purple-500/50 transition-colors" data-id="element-739">
                <ArrowDownAZ className="w-4 h-4" data-id="element-740" />
                <span data-id="element-741">Sırala: </span>
                <span className="text-purple-400" data-id="element-742">
                  {sortOption === 'newest' ? 'En Yeniler' : sortOption === 'mostReplies' ? 'En Çok Yanıtlananlar' : 'En Beğenilenler'}
                </span>
              </button>
              {showSortDropdown && <div className="absolute right-0 z-10 mt-1 w-56 bg-black/90 rounded-lg shadow-lg border border-gray-800 max-h-60 overflow-y-auto" data-id="element-743">
                  <button onClick={() => {
              setSortOption('newest');
              setShowSortDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${sortOption === 'newest' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-744">
                    <div className="flex items-center gap-2" data-id="element-745">
                      <ArrowDownAZ className="w-4 h-4" data-id="element-746" />
                      <span data-id="element-747">En Yeniler</span>
                    </div>
                  </button>
                  <button onClick={() => {
              setSortOption('mostReplies');
              setShowSortDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${sortOption === 'mostReplies' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-748">
                    <div className="flex items-center gap-2" data-id="element-749">
                      <MessageSquareText className="w-4 h-4" data-id="element-750" />
                      <span data-id="element-751">En Çok Yanıtlananlar</span>
                    </div>
                  </button>
                  <button onClick={() => {
              setSortOption('mostLikes');
              setShowSortDropdown(false);
            }} className={`w-full px-4 py-2 text-left hover:bg-purple-500/20 ${sortOption === 'mostLikes' ? 'bg-purple-500/20 text-purple-400' : 'text-white'}`} data-id="element-752">
                    <div className="flex items-center gap-2" data-id="element-753">
                      <Heart className="w-4 h-4" data-id="element-754" />
                      <span data-id="element-755">En Beğenilenler</span>
                    </div>
                  </button>
                </div>}
            </div>
          </div>
          <AuroraFloatingCard data-id="element-756">
            <div className="space-y-4" data-id="element-757">
              {sortedAndFilteredTopics.map(topic => <div key={topic.id} className={`p-4 rounded-lg bg-black/80 border ${topic.author === 'Ahmet Yönetici' ? 'border-purple-500/30 hover:border-purple-500/50' : 'border-white/10 hover:border-purple-500/30'} transition-colors cursor-pointer`} onClick={() => {
            setSelectedTopic(topic);
            setTopics(topics.map(t => t.id === topic.id ? {
              ...t,
              views: t.views + 1
            } : t));
          }} data-id="element-758">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-759">
                    <div className="flex-1" data-id="element-760">
                      <div className="flex items-center gap-2" data-id="element-761">
                        <h3 className="font-medium hover:text-purple-400 cursor-pointer" data-id="element-762">
                          {topic.title}
                        </h3>
                        {topic.author === 'Ahmet Yönetici' && <span className="px-2 py-0.5 text-xs rounded-full bg-purple-500/20 text-purple-400 whitespace-nowrap" data-id="element-763">
                            Benim Konum
                          </span>}
                        {topic.teacherApprovedId && <span className="text-green-400 flex items-center" title="Öğretmen Onaylı Çözüm" data-id="element-764">
                            <CheckCheck className="w-4 h-4" data-id="element-765" />
                          </span>}
                        {topic.bestAnswerId && <span className="text-blue-400 flex items-center" title="En İyi Cevap" data-id="element-766">
                            <Star className="w-4 h-4" data-id="element-767" />
                          </span>}
                        {topic.mostLikedAnswerId && (!topic.teacherApprovedId || topic.mostLikedAnswerId !== topic.teacherApprovedId) && (!topic.bestAnswerId || topic.mostLikedAnswerId !== topic.bestAnswerId) && <span className="text-purple-400 flex items-center" title="En Beğenilen Yanıt" data-id="element-768">
                              <Heart className="w-4 h-4" data-id="element-769" />
                            </span>}
                        {topic.image && <span className="text-purple-400 flex items-center" data-id="element-770">
                            <ImageIcon className="w-4 h-4" data-id="element-771" />
                          </span>}
                      </div>
                      <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-400" data-id="element-772">
                        <span data-id="element-773">{topic.author}</span>
                        {topic.category && <span className={`px-2 py-1 rounded-full ${getCategoryColor(topic.category)}`} data-id="element-774">
                            {topic.category}
                          </span>}
                        {topic.topic && <span className="px-2 py-1 rounded-full bg-purple-400/10 text-purple-400" data-id="element-775">
                            {topic.topic}
                          </span>}
                        <span data-id="element-776">{topic.time}</span>
                        {topic.visibility === 'private' && <span className="px-2 py-1 rounded-full bg-indigo-400/10 text-indigo-400" data-id="element-777">
                            Özel
                          </span>}
                        {topic.visibility === 'institution' && <span className="px-2 py-1 rounded-full bg-amber-400/10 text-amber-400" data-id="element-778">
                            Kuruma Özel
                          </span>}
                      </div>
                      {topic.content && <div className="mt-2 text-sm text-gray-400 line-clamp-2" data-id="element-779">
                          {topic.content}
                        </div>}
                    </div>
                    <div className="flex items-center gap-6 text-sm text-gray-400" data-id="element-780">
                      <button className={`flex items-center gap-1 ${topic.archived ? 'text-purple-400' : 'text-gray-400'} hover:text-purple-400 transition-colors`} onClick={e => {
                  e.stopPropagation();
                  handleArchiveTopic(topic.id);
                }} title="Arşive Ekle" data-id="element-781">
                        <Bookmark className="w-4 h-4" fill={topic.archived ? 'currentColor' : 'none'} data-id="element-782" />
                      </button>
                      <button className={`flex items-center gap-1 ${(topic.likedBy || []).includes('currentUser') ? 'text-purple-400' : 'text-gray-400'} hover:text-purple-400 transition-colors`} onClick={e => {
                  e.stopPropagation();
                  handleLikeTopic(topic.id);
                }} data-id="element-783">
                        <ThumbsUp className="w-4 h-4" fill={(topic.likedBy || []).includes('currentUser') ? 'currentColor' : 'none'} data-id="element-784" />
                        <span data-id="element-785">{topic.likes}</span>
                      </button>
                      <div className="flex items-center gap-1" data-id="element-786">
                        <MessageSquare className="w-4 h-4" data-id="element-787" />
                        <span data-id="element-788">{topic.replies}</span>
                      </div>
                      <div className="flex items-center gap-1" data-id="element-789">
                        <Eye className="w-4 h-4" data-id="element-790" />
                        <span data-id="element-791">{topic.views}</span>
                      </div>
                    </div>
                  </div>
                </div>)}
              {sortedAndFilteredTopics.length === 0 && <div className="text-center py-8 text-gray-400" data-id="element-792">
                  {personalFilter === 'my-topics' ? 'Henüz konu açmadınız. İlk konuyu siz başlatın!' : personalFilter === 'my-replies' ? 'Henüz yanıt yazmadınız. Diğer kullanıcıların konularına yanıt verin!' : activeTab === 'question' ? 'Henüz soru çözüm konusu bulunmuyor.' : 'Henüz tartışma konusu bulunmuyor. İlk konuyu siz başlatın!'}
                </div>}
            </div>
          </AuroraFloatingCard>
        </> : <ForumTopicDetail topic={selectedTopic} onClose={() => setSelectedTopic(null)} onAddReply={handleAddReply} onUpdateBestAnswer={(topicId, answerId) => {
      setTopics(topics.map(topic => topic.id === topicId ? {
        ...topic,
        bestAnswerId: answerId
      } : topic));
    }} onUpdateTeacherApproved={(topicId, answerId) => {
      setTopics(topics.map(topic => topic.id === topicId ? {
        ...topic,
        teacherApprovedId: answerId
      } : topic));
    }} onUpdateMostLiked={(topicId, answerId) => {
      setTopics(topics.map(topic => topic.id === topicId ? {
        ...topic,
        mostLikedAnswerId: answerId
      } : topic));
    }} onArchive={handleArchiveTopic} data-id="element-793" />}
      {showNewTopic && <NewForumTopic onClose={() => setShowNewTopic(false)} onSubmit={handleSubmitNewTopic} data-id="element-794" />}
    </div>;
}